import React from 'react';
import WebsiteLayout from './WebsiteLayout';
import AboutUsBanner from './components/AboutUsBanner';
import RobotServices from './components/RobotServices';
import AboutCO6 from './components/AboutCO6';
import MeetLeader from './components/meetLeader';
import GlobalPresence from './components/globalpresence';



const RoboticsAboutUs = () => {


    return(<>
    <WebsiteLayout>
     <AboutUsBanner/>
     <AboutCO6/>
     <RobotServices/>
     <MeetLeader/>
     <GlobalPresence/>
    </WebsiteLayout>
    </>);


}

export default RoboticsAboutUs;